export default "__VITE_ASSET__61a5fc2e__"